module.exports = __webpack_public_path__ + "static/media/Erhan_Yaylali_CV.b6e93054.pdf";